const IMAGE_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'])

export const normalizeChatFiles = (value: unknown): string[] => {
  if (value === null || value === undefined) {
    return []
  }

  if (Array.isArray(value)) {
    return [
      ...new Set(value.map(item => (typeof item === 'string' ? item.trim() : '')).filter(Boolean)),
    ]
  }

  if (typeof value !== 'string') {
    return []
  }

  const normalized = value.trim()

  if (normalized === '') {
    return []
  }

  try {
    const parsed = JSON.parse(normalized)

    if (typeof parsed === 'string' || Array.isArray(parsed)) {
      return normalizeChatFiles(parsed)
    }
  } catch (_error) {}

  return [normalized]
}

export const getChatFileName = (url: string): string => {
  try {
    const parsedUrl = new URL(url, window.location.origin)
    const pathname = parsedUrl.pathname || ''
    const name = pathname.split('/').filter(Boolean).pop()

    return name || url
  } catch (_error) {
    const chunks = url.split('?')[0].split('/').filter(Boolean)

    return chunks[chunks.length - 1] || url
  }
}

export const isImageChatFile = (url: string): boolean => {
  const pathname = url.split('?')[0]
  const ext = pathname.split('.').pop()?.toLowerCase() || ''

  return IMAGE_EXTENSIONS.has(ext)
}

export const uploadChatFiles = async (files: File[]): Promise<string[]> => {
  if (!files.length) {
    return []
  }

  const formData = new FormData()

  files.forEach(file => formData.append('file', file))

  const response = await fetch('/api/upload', {
    method: 'POST',
    body: formData,
    credentials: 'include',
  })

  const result = await response.json()

  if (!response.ok) {
    throw new Error(result?.message || 'Не удалось загрузить файлы')
  }

  if (Array.isArray(result?.url)) {
    return result.url.filter(
      (item: unknown): item is string => typeof item === 'string' && item.trim() !== '',
    )
  }

  if (typeof result?.url === 'string' && result.url.trim() !== '') {
    return [result.url.trim()]
  }

  throw new Error('Сервис загрузки не вернул ссылки на файлы')
}
